import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { GlobalService } from '../../../services/global.service';
import { EducationService } from '../../../services/education.service';
import { group_by_item_count, sortArrayOnKey } from '../../../../functions';

@Component({
  selector: 'app-home-schools-section',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, NgbCarouselModule],
  templateUrl: './home-schools-section.component.html',
})
export class HomeSchoolsSectionComponent {
  schoolData: any[] = [];

  schoolSlider = {
    slides_desktop: [] as any[],
    slides_mobile: [] as any[],
  };

  constructor(
    public global: GlobalService,
    private educationService: EducationService,
  ) {
    this.educationService.setHomeData();

    this.schoolData = this.educationService.homeData;
    if (!this.schoolData || this.schoolData.length === 0) {
      this.educationService.$homeDataSubject.subscribe(() => {
        this.schoolData = this.educationService.homeData;
        this.schoolSlider.slides_desktop = group_by_item_count(this.schoolData, 10);
        this.schoolSlider.slides_mobile = group_by_item_count(this.schoolData, 2);
      });
    } else {
      this.schoolSlider.slides_desktop = group_by_item_count(this.schoolData, 10);
      this.schoolSlider.slides_mobile = group_by_item_count(this.schoolData, 2);
    }

    if (this.schoolData.length > 0) {
      this.schoolData = sortArrayOnKey(this.schoolData, 'title');
      this.schoolData = sortArrayOnKey(this.schoolData, 'schoolType');
    }
  }
}
